export const FIRESTORE_PRODUCTS_TABLE = "products";
export const FIRESTORE_CATEGORIES_TABLE = "categories";
export const FIRESTORE_ORDERS_TABLE = "orders";
export const FIRESTORE_QUOTES_TABLE = "quotes";
export const FIRESTORE_DISCOUNT_CODES_TABLE = "discountCodes";
export const FIRESTORE_USERS_TABLE = "users";
export const FIRESTORE_GROUPS_TABLE = "groups";
export const FIRESTORE_COLLECTIONS_TABLE = "collections";
export const FIRESTORE_FEATURED_PRODUCTS_TABLE = "featuredProducts";
export const FIRESTORE_CARTS_TABLE = "carts";
export const FIRESTORE_DEALERS_TABLE = "dealers";
export const FIRESTORE_CHAT_SESSIONS_COLLECTION = "chatSessions";
export const FIRESTORE_QR_SCANS_COLLECTION = "qrScans";
